/* eslint-disable react/no-is-mounted */
// eslint-disable-next-line react-hooks/exhaustive-deps
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null, // Track the error object
      errorInfo: null, // Track additional error info
    };
  }

  static getDerivedStateFromError(error) {
    // Update state to indicate an error has occurred
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error and additional info
    console.error('ErrorBoundary caught an error:', error);
    console.error('Error details:', errorInfo);

    // Update state with error details
    this.setState({ error, errorInfo });
  }

  render() {
    const { children } = this.props;
    const { hasError, error, errorInfo } = this.state;

    if (hasError) {
      return (
        <div className="text-center">
          <h1 className="font-weight-bold text-uppercase">Oops...</h1>
          <h6 className="f-weight-6 text-uppercase text-info">
            Something went wrong here.
          </h6>
          {/* Optional: Display error details in development */}
          {process.env.NODE_ENV === 'development' && (
            <div className="text-danger mt-3">
              <p>
                <strong>Error:</strong> {error?.toString()}
              </p>
              <p>
                <strong>Details:</strong> {errorInfo?.componentStack}
              </p>
            </div>
          )}
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
